import EmptyState from '../components/EmptyState';

export default function Chunks() {
  return (
    <EmptyState
      title="Chunks"
      description="Chunk-based vocabulary content -- publishes standalone"
    />
  );
}
